<template>
  <div class='h100-60 noPage'>
    <ejs-grid ref='grid' height='calc(100% - 80px)' :rowSelected="watchRowSelected"></ejs-grid>
  </div>
</template>

<script>
import DetailTemplate from '../deployedInstance/DetailTemplate';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'Table',
  props: [
    'qryParam',
    'rowSelectedflag'
  ],
  data() {
    return {
      instanceColumns: [
        { field: 'runState', headerText: '状态', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'dname', headerText: '名称', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'deliverTypeStr', headerText: '交付方式', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'version', headerText: '交付版本', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        // { field: 'deployedCount', headerText: '数量', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'createTime', headerText: '创建时间', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'runEnvironment', headerText: '运行环境', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'idFlag', headerText: '操作', textAlign: 'Center', clipMode: 'EllipsisWithTooltip', template: this.detailTemplate }
      ],
      versionColumns: [
        { field: 'serviceName', headerText: '网元&服务名称', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'introduction', headerText: '介绍', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'type', headerText: '分类', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        // { field: 'deliverType', headerText: '交付方式', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'deployedCount', headerText: '部署总次数', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'createTime', headerText: '上架时间', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'idFlag', headerText: '操作', textAlign: 'Center', clipMode: 'EllipsisWithTooltip', template: this.detailTemplate }
      ],
      instanceColumnsInner: [
        { field: 'runState', headerText: '状态', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'dname', headerText: '名称', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'deliverTypeStr', headerText: '交付方式', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'version', headerText: '交付版本', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        // { field: 'deployedCount', headerText: '数量', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'createTime', headerText: '创建时间', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'runEnvironment', headerText: '运行环境', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
      ],
      versionColumnsInner: [
        { field: 'deliverType', headerText: '交付方式', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'pkgVersion', headerText: '交付版本', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'deployedCount', headerText: '部署数量', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'exist', headerText: '是否存在软件包', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'createTime', headerText: '创建时间', clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
      ],
      oamTypeCode: 0,
      columnsMap: {
        0: this.instanceColumns,
        1: this.versionColumns,
        2: this.instanceColumnsInner,
        3: this.versionColumnsInner,
      },
      neMap: {
        0: this.$t('System.neOAM'),
        3: this.$t('Topo.neMME'),
        4: this.$t('Topo.neHSS'),
        5: this.$t('Topo.nePGW'),
        6: this.$t('Topo.neSGW'),
        7: this.$t('Topo.nePCRF'),
        8: this.$t('Topo.neTCF'),
        9: this.$t('Topo.neTMF'),
        10: this.$t('Topo.nePDTGW'),
        11: this.$t('Topo.neDBS'),
        12: this.$t('Topo.neMC_CMS'),
        13: this.$t('Topo.neMC_CF'),
        14: this.$t('Topo.neMC_GMS'),
        15: this.$t('Topo.neMC_IDMS'),
        16: this.$t('Topo.neMC_PF'),
        17: this.$t('Topo.neBM_SC'),
        18: this.$t('Topo.neMBMS_GW'),
        19: this.$t('Topo.neFRS'),
        20: this.$t('Topo.neMC_TMF'),
        21: this.$t('Topo.nePRES'),
        23: this.$t('Topo.neP_HSS'),
        24: this.$t('Topo.neMC_KMS'),
        27: this.$t('Topo.neMCE'),
        28: this.$t('Topo.nePCDR'),
        31: this.$t('Topo.neDMS'),
        34: this.$t('Topo.neMC_GMS_NODE'),
        35: this.$t('Topo.neCU'),
        36: this.$t('Topo.neDU'),
        10001: this.$t('System.epcOAM'),
        10002: this.$t('System.imsOAM'),
        10003: this.$t('System.mcsOAM'),
        10004: this.$t('System.enodeb'),
        10007: this.$t('System.ibs_b'),
        10010: this.$t('System.ims_hytalk'),
        20001: this.$t('System.mcscl')
      },
      neType: {
        0: '基础',
        1: '业务'
      },
      deliverMap: { // 交付方式 0:native 老的enb和epc包 / 1:image 镜像包 / 2:helm 5GC包
        0: 'Native',
        1: 'Image',
        2: 'Helm',
        3: 'Vm'
      },
      envirMap: {
        1: 'DP',
        2: 'k8s',
        3: 'server',
        4: 'device'
      },
      existMap: {
        0: '存在',
        1: '不存在'
      },
      runstateMap: {
        0: '未部署',
        1: '未运行',
        2: '运行中',
        100: '已接入', // old网元的运行状态
      },
      url: '/lte/ems/',
      param: {

      }
    };
  },
  methods: {
    init(index, target = undefined) {
      const { qryParam } = this;
      console.log('qryParam=', qryParam);
      // 0-已部署实例（所有） 1-所有版本 2-指定产品或网元的已部署实例 3-指定产品或网元的服务列表
      const obj = this.$refs.grid.ej2Instances;
      if (index === 0) {
        obj.columns = this.instanceColumns;
        this.getInstanceList(qryParam, `${this.url}deployed/queryDeployedInfoAll`);
      } else if (index === 1) {
        obj.columns = this.versionColumns;
        this.getServiceList(qryParam, `${this.url}packageManager/queryServiceAll`);
      } else if (index === 2) {
        obj.columns = this.instanceColumnsInner;
        this.getInstanceList(qryParam, `${this.url}deployed/queryDeployedInfoAll`);
      } else if (index === 3) {
        obj.columns = this.versionColumnsInner;
        this.getServiceList(qryParam, `${this.url}packageManager/queryServiceAll`);
      }
    },
    handlerServerResult(res) {
      const result = res.data;
      const showRe = [];
      result.forEach(item => {
        const re = {};
        re.deliverTypeId = item.deliverType;
        re.deliverType = this.deliverMap[item.deliverType];
        re.serviceName = this.neMap[item.oamTypeCode];
        re.serviceId = item.oamTypeCode;
        re.introduction = '';
        re.type = this.neType[item.opType];
        re.instanceNum = '';
        re.createTime = item.createTime;
        re.deployedCount = item.deployedCount;
        re.idFlag = `0_${item.oamTypeCode}`;
        showRe.push(re);
      });
      this.$refs.grid.ej2Instances.dataSource = showRe;
      this.data = showRe;
    },
    handlerInstanceResult(res) {
      const result = res;
      const showRe = [];
      result.forEach(item => {
        const re = item;
        re.serviceId = item.oamTypeCode;
        re.runEnvironmentId = item.runEnvironment;
        re.runEnvironment = this.envirMap[re.runEnvironmentId];
        re.deliverTypeStr = this.deliverMap[item.deliverType];
        if (item.deliverType === 0) {
          re.runState = this.runstateMap[100];
        } else {
          // poc微服务--- 轮询查询？
          // d项目 --- 轮询查询？
          const queryParam = { };
          this.queryDeployedState(queryParam);
          const state = '1';
          re.runState = this.runstateMap[state];
        }
        re.idFlag = `1_${item.oamTypeCode}`;
        showRe.push(re);
      });
      this.$refs.grid.ej2Instances.dataSource = showRe;
      this.data = showRe;
    },
    getInstanceList(qryParam = undefined, url) {
      // TODO 运行状态查询
      const param = {};
      if (qryParam) {
        url = `${url}?oamTypeCode=${qryParam.oamTypeCode}`;
      }
      this.axios.get(url, param).then(res => {
        // if (qryParam === undefined) {
        //   this.handlerInstanceResult(res.data.resultVal);
        //   return;
        // }
        // this.initDataCallFun(res.data.resultVal);
        this.handlerInstanceResult(res.data.resultVal);
      });
    },
    initDataCallFun(res) {
      const $this = this;
      $this.$refs.grid.ej2Instances.dataSource = res;
      $this.data = res;
    },
    getServiceList(qryParam = undefined, url) {
      let urlNew = '/lte/ems/packageManager/findUpBackPackage';
      if (qryParam) {
        url = `${url}?oamTypeCode=${qryParam.oamTypeCode}`;
        urlNew = `${urlNew}?oamTypeCode=${qryParam.oamTypeCode}`;
      }
      this.axios.get(url).then(res => {
        const result = res.data;
        const showRe = [];
        let showReHasPkg = [];
        if (qryParam === undefined) {
          this.handlerServerResult(res);
        } else {
          // 查询是否存在软件包
          this.axios.get(urlNew).then(resHasPkg => {
            showReHasPkg = this.handlerPkgPackage(resHasPkg.data);
            result.forEach((item, index) => {
              const re = item;
              re.deliverTypeId = item.deliverType;
              re.deliverType = this.deliverMap[item.deliverType];
              re.serviceName = this.neMap[item.oamTypeCode];
              re.deployedCount = item.deployedCount;
              re.existNum = showReHasPkg[index].existNum;
              re.exist = this.existMap[re.existNum];
              re.serviceId = item.oamTypeCode;
              showRe.push(re);
            });
            this.$refs.grid.ej2Instances.dataSource = showRe;
            this.data = showRe;
            EventBus.$emit('updateTotalNum', { deployedNum: 0, versionNum: showRe.length });
          });
        }
      });
    },
    detailTemplate() {
      return {
        template: DetailTemplate
      };
    },
    // grid行选择
    watchRowSelected() {
      if (this.rowSelectedflag) {
        console.log('--------------', this.$refs.grid, this.$refs.grid.getSelectedRecords());
        EventBus.$emit('updateDetail', this.$refs.grid.getSelectedRecords()[0]);
      }
    },
    getParam() {
      const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record.length === 0) {
        this.$parent.showToast('warning', `${this.$t('System.selectDelObj')}`);
        return null;
      }
      return record;
    },
    // 判断是否存在软件包
    handlerPkgPackage(result) {
      const adapter = result.filter(item => item.pkgType === 0);
      const pkg = result.filter(item => item.pkgType === 1).map(item => {
        const { packageName, pkgVersion } = item;
        return {
          packageName,
          pkgVersion
        };
      });
      const serverPkg = result.filter(item => item.pkgType === 2).map(item => {
        const { packageName, pkgVersion } = item;
        return {
          packageName,
          pkgVersion
        };
      });
      const showRe = [];
      adapter.forEach(item => {
        const re = { upVersion: [] };
        re.deliverType = item.deliverType;
        re.deliverName = this.deliverMap[item.deliverType];
        re.deliverVersion = item.pkgVersion;
        const tempN = pkg.filter(it => it.packageName === item.packageName);
        const tempS = serverPkg.filter(it => it.packageName === item.packageName);
        if (Object.keys(tempN).length === 2) {
          // native 类型，检查是否存在升级包pkg(2个)
          re.existNum = 0;
          re.pkgType = 1;
          re.upVersion = tempN.map(re => re.pkgVersion);
        } else if (Object.keys(tempS).length === 1) {
          // image/helm类型，检查是否存在软件包
          re.existNum = 0;
          re.pkgType = 2;
          re.upVersion = tempS.map(re => re.pkgVersion);
        } else {
          re.existNum = 1;
        }
        re.exist = this.existMap[re.existNum];
        showRe.push(re);
      });
      return showRe;
    },
    /**
     * 查询已部署实例的运行状态(D项目、微服务)
     * @infoMap
     * 微服务查询单个需要的参数id（拓扑id）
     * D项目待定
     * typeCode和deliverType组合--后台根据参数判断给哪个产品下发
     */
    queryDeployedState(infoMap = {}) {
      console.log(infoMap);
      const url = `${this.url}deployed/queryDeployedState`;
      this.axios.post(url, infoMap).then(res => {
        console.log(res);
      });
    },
  },
};
</script>
